import styled from '@emotion/styled';

export const Informations = styled.div`
    h2 {
        text-align: center;
        color: #606060;
        font-weight: 400;
    }
`;
